export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q02_b.0fcf8a61.png";